import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { differenceBy, includes, intersectionBy, isEmpty, isNil, some } from 'lodash';
import { NoneValueHelper } from '../../core/';
import { FilterFieldValue } from '../covance-filter.models';
import { CovanceFilterSelectType } from './covance-filter-select-type';

@Injectable()
export class CovanceFilterMultiSelectType extends CovanceFilterSelectType {
    constructor(router: Router, route: ActivatedRoute, private noneValueHelper: NoneValueHelper) {
        super(router, route);
    }

    public isMatch(fieldVal: FilterFieldValue, value: any) {
        if (isEmpty(fieldVal.value)) {
            return true;
        }

        if (this.noneValueHelper.isNone(value)) {
            return some(fieldVal.value, m => this.noneValueHelper.isNone(m));
        }

        const filterValues = fieldVal.value.map((m: string) => m ? m.toLowerCase() : m);
        return includes(filterValues, value ? value.toLowerCase() : value);
    }

    public serializeValue(filterValue: any): string {
        return filterValue
            ? (filterValue as any[]).map(v => v.value || v.toString()).join(', ')
            : '';
    }

    public setValue(fieldVal: FilterFieldValue) {
        try {
            const queryParams: any[] = fieldVal.queryParamValue ? JSON.parse(fieldVal.queryParamValue) : null;
            if (!isEmpty(queryParams)) {
                fieldVal.value = intersectionBy(fieldVal.items, queryParams, (x: any) => this.getItemVal(x));
                const missingItems = differenceBy(queryParams, fieldVal.value, (x: any) => this.getItemVal(x));
                if (!isEmpty(missingItems) && !fieldVal.def.skipMissingItems) {
                    fieldVal.value.push(...missingItems);
                }
            } else {
                fieldVal.value = null;
            }

            this.addSelectedValueToSource(fieldVal);
        } catch (error) {
            fieldVal.queryParamValue = null;
        }
    }

    public setItems(fieldVal: FilterFieldValue, entities: any[]) {
        super.setItems(fieldVal, entities);
        this.setValue(fieldVal);
    }

    public setQueryParamValue(fieldVal: FilterFieldValue) {
        fieldVal.queryParamValue = !isEmpty(fieldVal.value) ? JSON.stringify(fieldVal.value.map((v: any) => this.getItemVal(v))) : null;
    }

    protected addSelectedValueToSource(fieldVal: FilterFieldValue) {
        if (isNil(fieldVal.value)) {
            this.sortItems(fieldVal);
            return;
        }
        if (isEmpty(fieldVal.items)) {
            fieldVal.items = [...fieldVal.value];
        } else {
            const missingItems = fieldVal.value.filter((p: any) => !fieldVal.items.find((i: any) => this.getItemVal(i) === this.getItemVal(p)));
            if (!isEmpty(missingItems)) {
                fieldVal.items.push(...missingItems);
            }
        }

        this.sortItems(fieldVal);
    }

    private getItemVal(item: any) {
        if (!item) {
            return null;
        }
        return item.key || item;
    }
}
